const LoadVerloopSupport = (isExist) => {
  if (isExist) {
    window.Verloop(function () {
      this.openWidget();
    });
  } else if (!document.getElementById('verloop__ID')) {
    (function (w, d, s, u) {
      w.Verloop = function (c) { w.Verloop._.push(c); };
      w.Verloop._ = [];
      w.Verloop.url = u;
      const h = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      j.async = true;
      j.id = 'verloop__ID';
      j.src = 'https://ketto.verloop.io/livechat/script.min.js';
      h.parentNode.insertBefore(j, h);
    }(window, document, 'script', 'https://ketto.verloop.io/livechat'));
  }
};
    
export default LoadVerloopSupport;
